import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Certifications from './components/Certifications';
// import References from './components/References';
import Trainings from './components/Trainings';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="pt-16"> {/* Add padding-top to account for fixed header */}
        <Hero />
        <Skills />
        <Projects />
        <Certifications />
        <Trainings />
        {/* <References /> */}
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
